export type Lang = 'zh' | 'en'

export const LANG_STORAGE_KEY = 'manamatch.lang'

export function isLang(value: unknown): value is Lang {
  return value === 'zh' || value === 'en'
}

/**
 * Which language to open in (Nai, 2026-09-21: 首次跟浏览器语言，之后记住用户选择).
 *
 * A stored choice always wins — someone who switched once meant it, and having the browser
 * override them on the next visit would make the switch look broken. With nothing stored, any
 * Chinese variant (zh, zh-CN, zh-Hant-HK …) opens in Chinese; everything else opens in English.
 *
 * Kept as a pure function so it can be tested without a browser, which is the only way to cover
 * the variants that matter here.
 */
export function resolveInitialLang(
  stored: string | null | undefined,
  preferred: readonly string[] | undefined,
): Lang {
  if (isLang(stored)) {
    return stored
  }

  for (const tag of preferred ?? []) {
    if (tag.toLowerCase().startsWith('zh')) {
      return 'zh'
    }
  }

  return 'en'
}

/** Reading storage throws in some privacy modes, and a language is never worth a blank page. */
export function readStoredLang(): string | null {
  try {
    return window.localStorage.getItem(LANG_STORAGE_KEY)
  } catch {
    return null
  }
}

export function writeStoredLang(lang: Lang): void {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang)
  } catch {
    // A viewer who blocks storage still gets the language they picked for this visit.
  }
}
